/**
 * Configuration for search functionality
 */
export interface SearchConfig {
  /**
   * Whether search is enabled
   */
  enabled: boolean;

  /**
   * Placeholder text for the search input (translation key)
   */
  placeholder?: string;

  /**
   * Debounce time in milliseconds
   * Default: 300
   */
  debounceMs?: number;

  /**
   * Minimum characters before triggering search
   * Default: 1
   */
  minChars?: number;

  /**
   * Search mode: AND requires all terms to match, OR requires any term to match
   * Default: 'OR'
   */
  mode?: 'AND' | 'OR';

  /**
   * Enable fuzzy search (partial matching)
   * Default: true
   */
  fuzzySearch?: boolean;

  /**
   * Highlight matching text in results
   * Default: false
   */
  highlightMatches?: boolean;
}
